import signalR = require("@microsoft/signalr");
import { app } from "../Frame/App";
import dom from "../../dist/jsx-render/dom";
import { AvatarProps, Avatar } from "../Components/UIElements/Avatar";
import { IWhoIsOnlineModel } from "../Controls/Widgets/Models/WhoIsOnlineWidgetModel";

export class OnlineUserManager {
    onlineConnection: signalR.HubConnection = null;
    onlineUers: IWhoIsOnlineModel[] = [];

    getSignalRConnection = () => {
        return new signalR.HubConnectionBuilder()
            .withUrl(app.resolveUrl("~/OnlineUsersHub"))
            .build();
    }

    public requestUpdate = () => {
        if (this.onlineConnection == null)
            this.onlineConnection = this.getSignalRConnection();

        this.refreshOnlineList();

        this.onlineConnection.start().then(() => {
            this.onlineConnection.invoke("UpdateStatusUser");}).catch(() => {
        });

        if (this.onlineConnection.state == signalR.HubConnectionState.Connected) {
            this.onlineConnection.invoke("UpdateStatusUser");
        }
    }

    getUserImage = (id: number, imageElement: HTMLImageElement): string => {
        let src: string = "";
        $.ajax({
            url: app.resolveUrl(`~/api/users/getUserThumbnail/${id}`),
            type: "GET",
            xhrFields: {
                responseType: 'blob' // to avoid binary data being mangled on charset conversion
            },
            success: (blob, status, xhr) => {
                var url = window.URL || window.webkitURL;
                imageElement.src = url.createObjectURL(blob);
            },
            error: (err) => {
                console.log(err);
                src = app.resolveUrl("~/images/dummy_person.png");
            }
        });
        return src;
    }

    public refreshOnlineList = () => {
        this.onlineConnection.on("updateStatusUser", function (response) {
            (app.onlineUserManager).onlineUers = response.usersConnected;
            let connectedUsers: IWhoIsOnlineModel[] = response.usersConnected;
            let divElement = document.querySelectorAll(".who-online-list");

            divElement.forEach(e => {
                let ulElement: HTMLElement = <ul class="list-group list-group-flush"></ul>;
                e.innerHTML = "";

                for (let item in connectedUsers) {
                    let liElement: HTMLElement = <li className="list-group-item d-flex align-items-center px-3 py-1"></li>;

                    let statusElement: HTMLElement = <span className="status-connected flex-shrink-0 rounded-circle mr-2"></span>;
                    liElement.appendChild(statusElement);

                    let avatarProps: AvatarProps = {
                        name: connectedUsers[item].name,
                        id: connectedUsers[item].id.toString(),
                        type: "user",
                        hasImage: connectedUsers[item].hasImage
                    };
                    let avatar = new Avatar(avatarProps);
                    let nameElement: HTMLElement = <span className="d-flex align-items-center flex-nowrap">{avatar.render()}{connectedUsers[item].name}</span>;
                    liElement.appendChild(nameElement);

                    ulElement.appendChild(liElement);
                }
                e.appendChild(ulElement);
            })
        });
    }


    onHubError = () => {
        this.onlineConnection.on("HubError ", function (response) {
            console.log(response.error);
        });
    }
}
